declare namespace $ {

	type $rise_devtools_selector__active_rise_devtools_plugin_1 = $mol_type_enforce<
		ReturnType< $rise_devtools_plugin['selecting'] >
		,
		ReturnType< $rise_devtools_selector['active'] >
	>
	type $rise_devtools_selector__done_rise_devtools_plugin_2 = $mol_type_enforce<
		ReturnType< $rise_devtools_plugin['selector_done'] >
		,
		ReturnType< $rise_devtools_selector['done'] >
	>
	type $rise_devtools_selector__rpc_port_rise_devtools_plugin_3 = $mol_type_enforce<
		ReturnType< $rise_devtools_plugin['rpc_port'] >
		,
		ReturnType< $rise_devtools_selector['rpc_port'] >
	>
	export class $rise_devtools_plugin extends $mol_plugin {
		keydown_listener( ): $mol_dom_listener | null
		selecting( next?: boolean ): boolean
		selector_done( next?: any ): any
		rpc_port( ): string
		selector( ): $rise_devtools_selector
		auto( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=plugin.view.tree.d.ts.map